import { render, staticRenderFns } from "./menu-version.vue?vue&type=template&id=4a882fb7&scoped=true"
import script from "./menu-version.vue?vue&type=script&lang=ts"
export * from "./menu-version.vue?vue&type=script&lang=ts"
import style0 from "./menu-version.vue?vue&type=style&index=0&id=4a882fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a882fb7",
  null
  
)

export default component.exports